import { render, staticRenderFns } from "./InboundMessageItem.vue?vue&type=template&id=a6e2aa8c&scoped=true&"
import script from "./InboundMessageItem.vue?vue&type=script&lang=js&"
export * from "./InboundMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./InboundMessageItem.vue?vue&type=style&index=0&id=a6e2aa8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e2aa8c",
  null
  
)

export default component.exports